import React from 'react';
import RoleplaySelectAssign from './RoleplaySelectAssign';
import RoleplayDeadline from './RoleplayDeadline';
import RoleplayScenarios from './RoleplayScenarios';
import Organization from 'infrastructure/Organization';
import RoleplaySelectAssignRep from './RoleplaySelectAssignRep';
import RoleplayBodyDetails from '../AssignRealPlay/RoleplayBodyDetails';
import RoleplayAIProspect from './RoleplayAIProspect';
import { useRoleplayStore } from 'features/roleplay/Roleplay.store';

const RoleplayModalBodyDetails = ({
  isLoadingAttitudes,
  isLoadingCoach,
  isInteractive,
  managerOption,
  publicOption,
  aiProspectOption,
}) => {
  const isRep = Organization.isRep();
  const { formDataAssignRoleplay } = useRoleplayStore();
  const isCreating = formDataAssignRoleplay?.roleplay?.value === -1;

  return isInteractive ? (
    <RoleplayBodyDetails
      isLoadingAttitudes={isLoadingAttitudes}
      isLoadingCoach={isLoadingCoach}
      publicOption={publicOption}
    />
  ) : (
    <div style={{ display: 'flex', gap: '0.5rem', flexDirection: 'column' }}>
      {(isRep && managerOption && !isInteractive) || (aiProspectOption && isCreating) ? null : (
        <p className="heading5" style={{ marginBottom: '0.5rem' }}>
          Roleplay details
        </p>
      )}
      <RoleplayScenarios />
      {!isRep ? (
        <>
          {aiProspectOption && isCreating && <RoleplayAIProspect />}
          <RoleplaySelectAssign />
        </>
      ) : (
        <RoleplaySelectAssignRep managerOption={managerOption} />
      )}
      <RoleplayDeadline />
    </div>
  );
};

export default RoleplayModalBodyDetails;
